export var IUploadFileTypes;
(function (IUploadFileTypes) {
    IUploadFileTypes["model_bin"] = "application/octet-stream";
    IUploadFileTypes["model_zip"] = "application/zip";
    IUploadFileTypes["model_gltf"] = "model/gltf+json";
    IUploadFileTypes["model_glb"] = "model/gltf-binary";
    IUploadFileTypes["model_glb_ext"] = ".glb";
    IUploadFileTypes["model_ext_fallback"] = ".glb,.gltf,.zip,.bin,.png,.jpg";
    IUploadFileTypes["video_all"] = "video/*";
    IUploadFileTypes["video_quicktime"] = "video/quicktime";
    IUploadFileTypes["video_avi"] = "video/x-msvideo";
    IUploadFileTypes["video_mp4"] = "video/mp4";
    IUploadFileTypes["video_mpeg"] = "video/mpeg";
    IUploadFileTypes["video_3gp"] = "video/3gpp";
    IUploadFileTypes["video_flv"] = "video/x-flv";
    IUploadFileTypes["video_webm"] = "video/webm";
    IUploadFileTypes["video_ext_fallback"] = ".webm,.mkv,.mov";
    IUploadFileTypes["image_jpeg"] = "image/jpeg";
    IUploadFileTypes["image_png"] = "image/png";
    IUploadFileTypes["image_ext_fallback"] = ".jpeg,.jpg,.png";
    IUploadFileTypes["audio_wav"] = "audio/wav";
    IUploadFileTypes["audio_mpeg"] = "audio/mpeg";
    IUploadFileTypes["audio_ogg"] = "audio/ogg";
    IUploadFileTypes["audio_m4a"] = "audio/m4a";
    IUploadFileTypes["audio_ext_fallback"] = ".wav,.ogg,.mp3,.mp4";
})(IUploadFileTypes || (IUploadFileTypes = {}));
export var IErrorText;
(function (IErrorText) {
    IErrorText["formatNotSupported"] = "format not supported";
    IErrorText["gltfMediaLibrary"] = "please upload via media library";
    IErrorText["fileDuplicate"] = "file duplicate";
})(IErrorText || (IErrorText = {}));
